import { Reducer } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ACTION,  DeleteUserMessage, SuccessNotification } from './action-types';
import { deepEquals } from 'app/infrastructure/js';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';

/**
 * Reducers for user messages.
 */
const reducers = {

  /**
   * Add user messages
   */
  [ACTION.DISPLAY_USER_MESSAGE]: (state: any, action: SuccessNotification | ErrorNotification) => {

    return {
      ...state,
      ...{
        app: {
          ...state.app,
          messages: [
            // prevent duplicates
            ...state.app.messages.filter(m => !deepEquals(m.data, action.message)),
            action.message
          ]
        }
      }
    };

  },

  /**
   * Removes user message from the ui
   */
  [ACTION.DELETE_USER_MESSAGE]: (state: any, action: DeleteUserMessage) => {
    return {
      ...state,
      ...{
        app: {
          ...state.app,
          messages: state.app.messages.filter(m => !deepEquals(m, action.message))
        }
      }
    };
  }
};

export const reducer: Reducer<any> = (state : ApplicationState, action: any) => {

  const r: any = reducers[action.type];
  return (r && r(state, action)) || state;
};
